export default {"src":"/_next/static/media/trueCircle.232d6aef.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};